import {AcceptorsFilterForm} from '../model';
import {AcceptorResponsePayload} from '../../../models/api/acceptorResponsePayload';

export const getAcceptorsFilterName = (key: string, type: string = ''): string => {
  return type ? `${type}.${key}` : key;
};

export const filterAcceptorsList =
  (filter?: AcceptorsFilterForm) =>
  (item: AcceptorResponsePayload): boolean => {
    let isMatch = true;
    if (!item.category) {
      return isMatch;
    }
    if (
      isMatch &&
      filter?.category &&
      !filter.category[0] &&
      !Object.values(filter.category).every((status) => !status)
    ) {
      isMatch = filter.category[item.category];
    }
    return isMatch;
  };
